import { TimingSystems } from '@racemap/utilities/consts/events';
import type { FC } from 'react';
import { DocuLink, ExternalLink, VStack } from 'src/components/BasicComponents';
import { useCurrentEvent } from 'src/lib/customHooks/useCurrentEvent';

export const ChronoTrackConfiguration: FC = () => {
  const event = useCurrentEvent();

  if (event == null || event.modules.predictive.timingsystem !== TimingSystems.CHRONO_TRACK)
    return <></>;

  return (
    <div style={{ marginLeft: '10px', width: '100%' }}>
      <VStack>
        <p>
          Read the
          <DocuLink
            path="predictive-tracking-with-data-from-timekeeping/other-timing-sytem#foward-data"
            style={{ margin: '1ch' }}
          />
          to set up ChronoTrack for forwarding reads to Racemap.
        </p>
        <p>
          Use the{' '}
          <ExternalLink
            label="2-racemap-forwarder"
            link={'https://github.com/racemap/2-racemap-forwarder'}
          />{' '}
          from github to forward reads to Racemap.
        </p>
        <p>
          As far as we know. ChronoTrack hardware does not support geolocation forwarding by
          default. You have to set locations for all your hardware manually in the map tab.
        </p>
      </VStack>
    </div>
  );
};
